import {
  FETCH_PVS_CATEGORY_DETAILS_REQUEST,
  FETCH_PVS_CATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_CATEGORY_DETAILS_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchPvsCategoryDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PVS_CATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case FETCH_PVS_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Category details fetched successfully",
      };

    case FETCH_PVS_CATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to fetch category details",
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchPvsCategoryDetailReducer;
